<div class="status-cell-container "[ngClass]="cellClass" (click)="openModal();">
  {{ displayValue }}
</div>
